import React, { useContext, useState } from "react";
import { AddDealerContext } from "../AddDealerView";
import "./addDealer.css";
import ContentData from "../../../../constants/contentFile.json";
import Loader from "../../../../components/Loader/Loader";
import { Col, Container, Row } from "react-bootstrap";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import NextIcon from "../../../../assets/images/next-icon.svg";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import SelectItem from "../../../../components/ThemeSelectOption/SelectOption";
import { StateOptions } from "../../../../constants/Constants";
import PluseIcon from "../../../../assets/images/pluse.svg";
import DownloadIcon from "../../../../assets/images/icons/download.svg";
import BulkUpload from "../../../../components/BulkUploadModal/BulkUpload";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const AddDealer = () => {
  const {
    formData,
    goToDealerList,
    handleChange,
    addDealer,
    successAlertMessage,
    successAlertShow,
    spinnerStatus,
    handleSelectData,
    bulkUpload,
    permissionAccess,
    downloadTemplate,
    handleDownloadExcel,
    onClearFile,
    handleCancel,
    handleBulkUploadSubmit,
    handleFileChange,
    showModal,
    setShowModal,
    errorCount,
    validationErrors,
    regionId,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    goToLogin,
    buttonText,
    statusValue,
  } = useContext(AddDealerContext);

  return (
    <>
      <div className="pageBg add-dealer">
        <div className="breadCrums">
          <span className="breadCrumsPointing" onClick={goToDealerList}>
            {ContentData.DealerPage.pageTitle}
          </span>
          <img className="nextIcon" src={NextIcon} alt="next icon" />

          <span className="boldBreadCrums">
            {ContentData.DealerPage.addDealer}
          </span>
        </div>
        {spinnerStatus && <Loader />}

        {/* inverter */}
        <Container>
          <div className="title-section">
            <button type="button" onClick={goToDealerList} class="navbar-btn">
              <img src={ToggleArrow} alt="toggle-arrow" />
            </button>
            <div className="pageTittles">
              {ContentData.DealerPage.addDealer}
            </div>
            <div>
              <div className="bulk-data">
                <div className="download-template" onClick={downloadTemplate}>
                  {ContentData.DealerPage.downloadTemplate}
                  <img src={DownloadIcon} />
                </div>
                <div
                  className={`addProduct  addDataProduct ${
                    permissionAccess?.add ? "" : "disabledMainButton"
                  } `}
                  onClick={bulkUpload}
                >
                  <img src={PluseIcon} alt="add" />
                  <span>{ContentData.DealerPage.bulkUpload}</span>
                </div>
              </div>
            </div>
          </div>

          <form className="adminUserSection" onSubmit={addDealer}>
            <div className="basicContainer">
              <div className="viewAdminSection addAdminSection">
                <Row>
                  {/* customer code */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.customerCode} *</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterCode}
                          name="customerCode"
                          value={formData.customerCode}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.customerCode && (
                          <p className="mb-0 error-msg">
                            {validationErrors.customerCode}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* customer name */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.customerName} *</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterCustomerName}
                          name="customerName"
                          value={formData.customerName}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.customerName && (
                          <p className="mb-0 error-msg">
                            {validationErrors.customerName}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/*Contact no */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.contactNo}*</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterContactNo}
                          name="mobile"
                          value={formData.mobile}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.mobile && (
                          <p className="mb-0 error-msg">
                            {validationErrors.mobile}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/*Region */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.region}*</h4>
                        <SelectItem
                          selectPlaceholder={
                            ContentData.DealerPage.selectRegion
                          }
                          values={StateOptions}
                          selectNum={"value"}
                          label={"label"}
                          handleSelectData={handleSelectData}
                          defaultValue={regionId}
                        />
                        {validationErrors.region && (
                          <p className="mb-0 error-msg">
                            {validationErrors.region}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* District */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.district}*</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterDistrict}
                          name="district"
                          value={formData.district}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.district && (
                          <p className="mb-0 error-msg">
                            {validationErrors.district}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* city */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.city}*</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterCity}
                          name="city"
                          value={formData.city}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.city && (
                          <p className="mb-0 error-msg">
                            {validationErrors.city}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* address */}
                  <Col xl="8" lg="8" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.address} *</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterAddress}
                          name="streetOrHouseNumber"
                          value={formData.streetOrHouseNumber}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.streetOrHouseNumber && (
                          <p className="mb-0 error-msg">
                            {validationErrors.streetOrHouseNumber}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* postal code */}
                  <Col xl="4" lg="4" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.DealerPage.postalCode} *</h4>
                        <InputComponent
                          placeholder={ContentData.DealerPage.enterPostalCode}
                          name="postalCode"
                          value={formData.postalCode}
                          type="text"
                          onChange={handleChange}
                        />
                        {validationErrors.postalCode && (
                          <p className="mb-0 error-msg">
                            {validationErrors.postalCode}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="bottomButtons">
              <BorderButton
                value={ContentData.authPage.cancelText}
                onClick={goToDealerList}
              />
              <ThemeButton
                value={ContentData.authPage.submitText}
                id="submitAddEditBtn"
                type="submit"
              />
            </div>
          </form>
          <SuccessPopupAlert
            show={successAlertShow}
            alertMessage={successAlertMessage}
            handleSubmit={goToDealerList}
          />
        </Container>
      </div>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />

      <BulkUpload
        show={showModal}
        setShow={setShowModal}
        handleSubmit={handleBulkUploadSubmit}
        handleCancel={handleCancel}
        handleDownloadExcel={handleDownloadExcel}
        onChange={handleFileChange}
        accept=".xls,.xlsx"
        onClearFile={onClearFile}
        errorCount={errorCount}
      />
    </>
  );
};

export default AddDealer;
